var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import Breadcrumb from "bootstrap-vue/es/components/breadcrumb/breadcrumb";
import BreadcrumbItem from "bootstrap-vue/es/components/breadcrumb/breadcrumb-item";
import CardGroup from "bootstrap-vue/es/components/card/card-group";
import Card from "bootstrap-vue/es/components/card/card";
import PhoneNumber from "../Components/PhoneNumber.vue";
import Distance from "../Components/Distance.vue";
import * as BingMaps from "../Helpers/BingMaps.ts";
import bFormSelect from "bootstrap-vue/es/components/form-select/form-select";
import bFormInput from "bootstrap-vue/es/components/form-input/form-input";
import bInputGroup from "bootstrap-vue/es/components/input-group/input-group";
import bInputGroupAddon from "bootstrap-vue/es/components/input-group/input-group-addon";
import Tooltip from "bootstrap-vue/es/directives/tooltip/tooltip";
var credentials = window.config.bingMap.credentials;
var BingMap = /** @class */ (function (_super) {
    __extends(BingMap, _super);
    function BingMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isGps = false;
        _this.canUseGps = true;
        _this.locationSearchText = "";
        _this.locationSearchError = "";
        _this.locationSearchResults = [];
        _this.localRadius = _this.radius;
        _this.rendered = false;
        _this.activeNearby = null;
        _this.nearbyResults = [];
        _this.nearbyResultsTotal = 0;
        _this.activeNearbyResult = null;
        _this.dataset = [];
        _this.datasetResults = [];
        _this.activeDatasetResult = null;
        return _this;
    }
    BingMap.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, address, search, location_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, BingMaps.create(this.credentials, this.$refs.root)];
                    case 1:
                        _a.map = _b.sent();
                        if (!this.useGps) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.onGpsClick()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!this.location) return [3 /*break*/, 6];
                        address = this.location;
                        return [4 /*yield*/, this.map.getSearch()];
                    case 4:
                        search = _b.sent();
                        return [4 /*yield*/, search.geocode(address.line1, address.city, address.state, address.zip)];
                    case 5:
                        location_1 = (_b.sent()).results
                            .map(function (p) { return p.location; })[0];
                        this.setNonGpsLocation(location_1);
                        _b.label = 6;
                    case 6:
                        if (!(this.addresses.length !== 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.initializeDataset(this.addresses)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        this.rendered = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onGpsClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var location;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.locationSearchText = "";
                        this.setLocationSearchError();
                        this.locationSearchResults = [];
                        return [4 /*yield*/, this.map.addCurrentLocationPushpin()];
                    case 1:
                        location = _a.sent();
                        this.map.setViewToAll();
                        this.canUseGps = !!location;
                        this.isGps = !!location;
                        return [4 /*yield*/, this.calculateDatasetDistance()];
                    case 2:
                        _a.sent();
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.setNonGpsLocation = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.addCurrentLocationPushpin(location)];
                    case 1:
                        _a.sent();
                        this.map.setViewToAll();
                        this.isGps = false;
                        return [4 /*yield*/, this.calculateDatasetDistance()];
                    case 2:
                        _a.sent();
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onLocationSearchClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var search, results, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocationSearchError();
                        this.locationSearchResults = [];
                        if (!this.locationSearchText)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.map.getSearch()];
                    case 1:
                        search = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, search.geocode(this.locationSearchText)];
                    case 3:
                        results = (_b.sent()).results;
                        if (results.length === 0) {
                            this.setLocationSearchError("Could not find location");
                        }
                        else if (results.length === 1) {
                            this.setNonGpsLocation(results[0].location);
                        }
                        else {
                            this.locationSearchResults = results;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        this.setLocationSearchError("Could not find location");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onLocationSearchResultClick = function (result) {
        this.locationSearchText = result.name;
        this.setLocationSearchError();
        this.locationSearchResults = [];
        this.setNonGpsLocation(result.location);
    };
    BingMap.prototype.setLocationSearchError = function (error) {
        if (error === void 0) { error = ""; }
        this.locationSearchError = error;
        if (error) {
            this.$refs.locationSearch.focus();
        }
    };
    BingMap.prototype.searchNearby = function (nearby) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var term, search, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetNearby(false);
                        this.activeNearby = nearby;
                        term = typeof nearby === "object"
                            ? nearby.term
                            : nearby;
                        return [4 /*yield*/, this.map.getSpatialData()];
                    case 1:
                        search = _a.sent();
                        return [4 /*yield*/, search.nearby(term)];
                    case 2:
                        results = _a.sent();
                        this.nearbyResults = results.data
                            .map(function (p) {
                            var result = convertBingSearchResult(p, _this.map.module);
                            result.infoboxOptions = {
                                description: result.address.title
                            };
                            result.pin = _this.map.addPushpin(new _this.map.module.Location(p.metadata.Latitude, p.metadata.Longitude), undefined, result.infoboxOptions);
                            _this.map.module.Events.addHandler(result.pin, "mouseover", function () {
                                _this.activeNearbyResult = result;
                            });
                            return result;
                        });
                        this.nearbyResultsTotal = results.total;
                        this.map.setViewToAll();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.resetNearby = function (resetView) {
        if (resetView === void 0) { resetView = true; }
        this.activeNearby = null;
        this.nearbyResults = [];
        this.nearbyResultsTotal = 0;
        this.activeNearbyResult = null;
        this.map.clearPushpins();
        this.map.hideInfobox();
        if (resetView) {
            this.map.setViewToAll();
        }
    };
    BingMap.prototype.clickNearby = function (result) {
        this.overNearby(result);
    };
    BingMap.prototype.overNearby = function (result) {
        this.activeNearbyResult = result;
        result.location && result.infoboxOptions && this.map.showInfobox(result.location, result.infoboxOptions);
    };
    BingMap.prototype.outNearby = function (result) {
        this.activeNearbyResult = null;
        this.map.hideInfobox();
    };
    BingMap.prototype.initializeDataset = function (addresses) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var search, locationSearches;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.getSearch()];
                    case 1:
                        search = _a.sent();
                        this.dataset = addresses.map(function (p) {
                            return {
                                address: p,
                                distance: 0,
                                infoboxOptions: {
                                    description: p.title
                                }
                            };
                        });
                        locationSearches = this.dataset.map(function (p) { return search.geocode(p.address.line1, p.address.city, p.address.state, p.address.zip); });
                        Promise.all(locationSearches).then(function (locations) {
                            for (var i = 0; i < locations.length; i++) {
                                _this.dataset[i].location = locations[i].results[0].location;
                                _this.dataset[i].distance = i;
                            }
                        })
                            .then(function (p) { return _this.calculateDatasetDistance(); })
                            .then(function (p) { return _this.sortAndFilterDataset(); });
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.calculateDatasetDistance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var spatialMath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.getSpatialMath()];
                    case 1:
                        spatialMath = _a.sent();
                        this.dataset
                            .filter(function (p) { return !p.location || !_this.map.currentLocation; })
                            .forEach(function (p) { return p.distance = 0; });
                        this.dataset
                            .filter(function (p) { return !!p.location && !!_this.map.currentLocation; })
                            .forEach(function (p) { return p.distance = spatialMath.getDistanceTo(_this.map.currentLocation, p.location, Microsoft.Maps.SpatialMath.DistanceUnits.Miles); });
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.sortAndFilterDataset = function (radius) {
        var _this = this;
        radius = radius || this.localRadius;
        this.datasetResults = this.dataset
            .filter(function (p) { return radius === -1 || p.distance <= radius; })
            .sort(function (l, r) { return l.distance - r.distance; });
        this.map.clearPushpins();
        this.datasetResults
            .filter(function (p) { return !!p.location; })
            .forEach(function (p) { return p.pin = _this.map.addPushpin(p.location, undefined, p.infoboxOptions); });
        this.map.setViewToAll();
    };
    BingMap.prototype.overDatasetResult = function (result) {
        this.activeDatasetResult = result;
        result.location && result.infoboxOptions && this.map.showInfobox(result.location, result.infoboxOptions);
    };
    BingMap.prototype.outDatasetResult = function (result) {
        this.activeDatasetResult = null;
        this.map.hideInfobox();
    };
    BingMap.prototype.reset = function () {
        this.resetNearby();
        this.map.resetView();
    };
    __decorate([
        Prop({ type: String, default: credentials })
    ], BingMap.prototype, "credentials", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BingMap.prototype, "useGps", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BingMap.prototype, "useLocationSearch", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BingMap.prototype, "useRadius", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return [
                { value: 25, text: "25 miles" },
                { value: 100, text: "100 miles" },
                { value: 250, text: "250 miles" },
                { value: -1, text: "All" },
            ]; } })
    ], BingMap.prototype, "radii", void 0);
    __decorate([
        Prop({ type: Number, default: -1 })
    ], BingMap.prototype, "radius", void 0);
    __decorate([
        Prop({ type: Object })
    ], BingMap.prototype, "location", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], BingMap.prototype, "nearby", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], BingMap.prototype, "addresses", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BingMap.prototype, "showAddressesList", void 0);
    BingMap = __decorate([
        Component({
            name: "BingMap",
            directives: {
                "b-tooltip": Tooltip
            },
            components: {
                PhoneNumber: PhoneNumber,
                Distance: Distance,
                "b-row": Row,
                "b-col": Col,
                "b-breadcrumb": Breadcrumb,
                "b-breadcrumb-item": BreadcrumbItem,
                "b-card-group": CardGroup,
                "b-card": Card,
                "form-input": bFormInput,
                "input-group": bInputGroup,
                "input-group-addon": bInputGroupAddon,
                "form-select": bFormSelect
            }
        })
    ], BingMap);
    return BingMap;
}(Vue));
export default BingMap;
;
function convertBingSearchResult(result, module) {
    return {
        address: {
            title: result.metadata.DisplayName,
            line1: result.metadata.AddressLine,
            city: result.metadata.AdminDistrict2,
            state: result.metadata.AdminDistrict,
            zip: result.metadata.PostalCode,
            phoneNumber: result.metadata.Phone
        },
        distance: result.metadata.__Distance,
        location: new module.Location(result.metadata.Latitude, result.metadata.Longitude)
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/BingMap.vue
// module id = 164
// module chunks = 0 1 5